import { ICalendar } from '@/types';
import { getUrl } from '@/utils/api';

function useCalendars() {
  const query = getUrl(`v1/calendars`);
  return {
    ...query,
    data: query.data as ICalendar[],
  };
}

export default useCalendars;
